// extracted by mini-css-extract-plugin
export var black = "_1z-6";
export var brand = "_1z-1";
export var ddefault = "_1z-0";
export var error = "_1z-3";
export var gray = "_1z-2";
export var highContrast = "_1z-8";
export var outline = "_1z-7";
export var success = "_1z-5";
export var warning = "_1z-4";